<app-skeleton *ngIf="loading" variant="text" [count]="8"
  label="Carregando o broadcast de WhatsApp" data-testid="broadcast-whatsapp-loading"></app-skeleton>

<div *ngIf="!loading && broadcast">
  <app-page-title icon="fa-bullhorn" title="Envio em Massa">
    <a [routerLink]="['/broadcasts-whatsapp/new']" class="sf-btn sf-btn--primary sf-btn--pill">
      Criar Envio em Massa (Whatsapp) <i class="fa fa-paper-plane-o"></i>
    </a>
  </app-page-title>

  <div class="card gradient-row primary" *ngIf="broadcast?.id && isImporting">
    Os Leads deste Broadcast estão sendo importados. Assim que finalizar você
    será notificado.
  </div>

  <div class="row mb-2">
    <div class="col">
      <div class="form-group">
        <label>Campanha:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.name"
          readonly
        />
      </div>
    </div>

    <div class="col">
      <div class="form-group">
        <label>Data/Hora do Envio:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.last_sent_date | date : 'dd/MM/yyyy, H:mm'"
          readonly
        />
      </div>
    </div>

    <div class="col">
      <div class="form-group">
        <label>Status:</label>
        <input
          type="text"
          class="form-control"
          [value]="status"
          readonly
        />
      </div>
    </div>

    <div class="col" *ngIf="broadcast.short_url">
      <div class="form-group">
        <label>Total clicks:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.clicks"
          readonly
        />
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-12" *ngIf="broadcast.leadList">
      <div class="form-group">
        <label>Lista:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.leadList.name"
          readonly
        />
      </div>
    </div>
  </div>

  <div class="form-group mb-2">
    <label>Mensagem:</label>
    <textarea class="form-control" readonly rows="3">{{
      broadcast.message
    }}</textarea>
  </div>

  <div class="row my-4" *ngIf="broadcast.image">
    <div class="col-md-3">
      <div class="base-64-imgage-container">
        <img class="base-64-image" [src]="broadcast.image" alt="">
      </div>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-3">
      <div class="form-group">
        <label>Total de leads:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.leads_count"
          readonly
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label>Total enviado:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.total_sent"
          readonly
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label>Total de erros:</label>
        <input
          type="text"
          class="form-control"
          [value]="broadcast.total_errors"
          readonly
        />
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label>Total aguardando envio:</label>
        <input
          type="text"
          class="form-control"
          [value]="
            broadcast.leads_count -
            broadcast.total_sent -
            broadcast.total_errors
          "
          readonly
        />
      </div>
    </div>
  </div>

  <div class="row" *ngIf="broadcast.url">
    <div class="col form-group">
      <label>URL:</label>
      <input
        type="text"
        class="form-control"
        readonly
        id="url"
        [value]="broadcast.url"
        (click)="copyUrl()"
      />
    </div>
    <div class="col form-group">
      <label>URL Curta:</label>
      <input
        type="text"
        class="form-control"
        readonly
        id="short_url"
        [value]="broadcast.short_url"
        (click)="copyShortUrl()"
      />
    </div>
  </div>

  <div class="mt-2" *ngIf="broadcast.reason">
    <label>Motivo do cancelamento</label>
    <textarea class="form-control" readonly rows="2">{{
      broadcast.reason
    }}</textarea>
  </div>

  <div class="mt-2">
    <a
      [routerLink]="['/broadcasts-whatsapp', broadcast.id]"
      class="sf-btn sf-btn--primary mb-3 me-2"
      *ngIf="isScheduled"
    >
      Alterar
    </a>

    <a [routerLink]="['/broadcasts-whatsapp']" class="sf-btn sf-btn--secondary mb-3">
      Voltar
    </a>
  </div>

  <app-skeleton *ngIf="loadingContacts" variant="table-row" [count]="8" [columns]="4"
    label="Carregando os contatos" data-testid="contacts-loading"></app-skeleton>

  <table class="table table-hover elevated" *ngIf="!loadingContacts">
    <thead>
      <tr>
        <th>Telefone</th>
        <th>Mensagem</th>
        <th>Data Envio</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody *ngIf="contacts && contacts.data.length > 0; else notFound">
      <tr *ngFor="let contact of contacts.data">
        <td>{{ contact.phone }}</td>
        <td>{{ contact.message || "-" }}</td>
        <td>
          <span *ngIf="contact.sent_date">{{
            contact.sent_date | date : "dd/MM/yyyy, H:mm"
          }}</span>
          <span *ngIf="!contact.sent_date">-</span>
        </td>
        <td>
          {{ getStatus(contact) }}
        </td>
      </tr>
    </tbody>
  </table>

  <app-pagination
    *ngIf="!loadingContacts && contacts"
    [currentPage]="contacts.current_page"
    [itemsPerPage]="contacts.per_page"
    [totalItems]="contacts.total"
    (pageChanged)="pageChanged($event)"
  >
  </app-pagination>
</div>

<ng-template #notFound>
  <tbody>
    <tr *ngIf="contacts">
      <td colspan="2">Nenhuma mensagem enviada</td>
    </tr>
  </tbody>
</ng-template>
